import { Route } from "react-router-dom";
import InboxScreen from "./InboxScreen.tsx";

export const routes = <Route path="/my/inbox/:id?" Component={InboxScreen} />;
